function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import JournalEvent from "core/models/journal-event";
import tWithDefault from "core/utils/t-with-default";
import dayjs from "dayjs";
import { validateDate, validatePresence } from "ember-changeset-validations/validators";
import IntlService from "ember-intl/services/intl";

//---- Automatically generated, don't update this part ----

/**
 * Created when the consultation is ended.
 */
export default class OnlineConsultationEndedJournalEvent extends JournalEvent {
  static validations(intl) {
    return {
      occurredAt: [validatePresence({
        presence: true,
        description: tWithDefault(intl, "validations.online-consultation-ended-journal-event.occurred-at", "La date")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
        onOrAfter: new Date("01/01/1900")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
        onOrBefore: dayjs().endOf("day").toDate()
      })]
    };
  }

  //---- End of generated code ----
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
_defineProperty(OnlineConsultationEndedJournalEvent, "type", "online-consultation-ended-journal-event");